module.exports = __webpack_public_path__ + "static/media/SF_bm_sekundaerlogo_postale_agder_neg.7679b0d2.png";